import cls from "classnames";
import { useCallback, useEffect, useState, Fragment } from "react";
import { usePopper } from "react-popper";
import { Transition } from "@headlessui/react";

const showEvents = ["mouseenter", "focus", "click"];
const hideEvents = ["mouseleave", "blur"];

export default function Tooltip({
  description,
  className,
  referenceElement,
  backgroundColor = "#F9FAFB",
  showArrow = true,
}) {
  const [popperElement, setPopperElement] = useState(null);
  const [arrowElement, setArrowElement] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  const { styles, attributes } = usePopper(referenceElement, popperElement, {
    placement: "right",
    modifiers: [
      {
        name: "offset",
        options: {
          offset: [0, 8],
        },
      },
      {
        name: "preventOverflow",
        options: {
          altAxis: true,
          padding: {
            top: 0,
            bottom: 0,
            left: 20,
            right: 20,
          },
        },
      },
      {
        name: "flip",
        options: {
          fallbackPlacements: ["left", "bottom", "top"],
        },
      },
      { name: "arrow", options: { element: arrowElement } },
    ],
  });

  const show = useCallback(() => {
    setIsVisible(true);
  }, []);

  const hide = useCallback(() => {
    setIsVisible(false);
  }, []);

  useEffect(() => {
    if (referenceElement) {
      showEvents.forEach((event) => {
        referenceElement.addEventListener(event, show);
      });
      hideEvents.forEach((event) => {
        referenceElement.addEventListener(event, hide);
      });
    }
    return () => {
      if (referenceElement) {
        showEvents.forEach((event) => {
          referenceElement.removeEventListener(event, show);
        });
        hideEvents.forEach((event) => {
          referenceElement.removeEventListener(event, hide);
        });
      }
    };
  }, [referenceElement]);

  return (
    <Transition
      show={isVisible}
      as="div"
      className="z-20"
      enter="transiton-all ease-out duration-200"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="transition-all ease-in duration-100"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      <div
        className={cls("max-w-[284px]")}
        ref={setPopperElement}
        style={styles.popper}
        {...attributes.popper}
      >
        {showArrow && (
          <div ref={setArrowElement} style={styles.arrow} className="tooltip-arrow-wrapper">
            <div className="tooltip-arrow" style={{ backgroundColor: backgroundColor }}></div>
          </div>
        )}
        <div
          className={cls(
            "py-2 px-4 text-sm font-medium text-gray-900 rounded overflow-hidden shadow-lg border border-black border-opacity-5",
            className
          )}
          style={{
            backgroundColor: backgroundColor
          }}
        >
          {description}
        </div>
      </div>
    </Transition>
  );
}
